import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../../common/store/types';
import { KnownIpAddressModel } from './types';
import { knownIpAddressActions } from './known-ip-address.actions';

export interface IKnownIpAddressState extends IState<KnownIpAddressModel> {
  getById: GenericState<KnownIpAddressModel>;
  update: GenericState<KnownIpAddressModel>;
}

export const knownIpAddressInitialState: IKnownIpAddressState = {
  getById: new GenericState<KnownIpAddressModel>(),
  update: new GenericState<KnownIpAddressModel>(),
};

const knownIpAddressReducers = [
  ...onApiCall<KnownIpAddressModel>(knownIpAddressActions.getById, 'getById'),
  ...onApiCall<KnownIpAddressModel>(knownIpAddressActions.update, 'update'),
];

export const knownIpAddressReducer = createReducer(
  knownIpAddressInitialState,
  ...knownIpAddressReducers,
) as ActionReducer<IKnownIpAddressState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return knownIpAddressReducer(state, action);
}
